import {createMaterialBottomTabNavigator} from 'react-native-paper/react-navigation';
import _ from 'lodash';

import SearchScreen from '~/screens/search';
import withProtectedScreen from '~/components/hoc/with-protected-screen';

import SearchIcon from '~/images/md-icons/search/materialicons/24px.svg';
import SearchOutlinedIcon from '~/images/md-icons/search/materialiconsoutlined/24px.svg';

const TabsStack = createMaterialBottomTabNavigator();

export default ({route}) => {
  let {initialRouteName} = route.params ?? {};
  if (!initialRouteName) {
    // We don't have an initial route yet so we can't render the tabs
    return null;
  }

  return (
    <TabsStack.Navigator
      initialRouteName={initialRouteName}
      shifting={false}
      activeColor="#231fda"
      inactiveColor="#757575"
      barStyle={{
        backgroundColor: '#ffffff',
        borderTopColor: '#dcdcdc',
        borderTopWidth: 1,
      }}
      safeAreaInsets={{bottom: 0}}
      screenOptions={{
        headerShown: false,
      }}>
      <TabsStack.Screen
        name="Search"
        options={{
          title: 'Opdrachten',
          tabBarIcon: ({focused, color}) =>
            focused ? (
              <SearchOutlinedIcon fill={color} />
            ) : (
              <SearchIcon fill={color} />
            ),
        }}
        component={withProtectedScreen(SearchScreen)}
      />
    </TabsStack.Navigator>
  );
};
